import { useEffect, useState } from 'react';

export const READINESS_TIMEOUT_MS = 30 * 1000;

export function useReadinessDeadline(
    waiting: boolean,
    resetKey: string,
): boolean {
    const [expired, setExpired] = useState(false);

    useEffect(() => {
        setExpired(false);
        if (!waiting) return;

        const timeout = setTimeout(
            () => setExpired(true),
            READINESS_TIMEOUT_MS,
        );
        return () => clearTimeout(timeout);
    }, [waiting, resetKey]);

    return expired;
}
